<template>
  <Modal
    :model-value="showModal"
    :show-close="true"
    :close-on-click-outside="false"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <div
      v-if="showModal && car"
      class="max-h-[min(70vh,calc(100vh-8rem))] overflow-y-auto overscroll-contain"
    >
      <ConfirmMerchantConsultationForm
        v-if="activeTab === Tab.MERCHANT_CONSULTATION"
        :car="car"
        @complete="showModal = false"
      />
      <CarIncomingForm
        v-if="activeTab === Tab.CAR_INCOMING"
        :car="car"
        @complete="showModal = false"
      />
      <WorkshopAppointmentForm
        v-if="activeTab === Tab.WORKSHOP_APPOINTMENTS"
        :car="car"
        @open-workshop-appointment="handleOpenWorkshopAppointment"
        @complete="showModal = false"
      />
      <EnterTuvAppointmentDateForm
        v-if="activeTab === Tab.TUV"
        :car="car"
        @complete="showModal = false"
      />
      <ChangeTyresForm
        v-if="activeTab === Tab.TYRE_CONDITION"
        :car="car"
        @complete="showModal = false"
      />
      <SellCarForm v-if="activeTab === Tab.SELL" :car="car" @complete="showModal = false" />
    </div>
  </Modal>
</template>

<script lang="ts" setup>
import { VehiclePoolTab as Tab } from '../vehicle-pool-tab.enum';
import type { Car } from '@/entities/cars/car.entity';
import type { WorkshopAppointment } from '@/entities/workshop-appointments/workshop-appointment.entity';
import ConfirmMerchantConsultationForm from './ConfirmMerchantConsultationForm.vue';
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import CarIncomingForm from './CarIncomingForm.vue';
import WorkshopAppointmentForm from './WorkshopAppointmentForm.vue';
import EnterTuvAppointmentDateForm from './EnterTuvAppointmentDateForm.vue';
import ChangeTyresForm from '@/views/vehicle-pool/vehicle-pool-list/components/ChangeTyresForm.vue';
import SellCarForm from './SellCarForm.vue';
import Modal from '@/components/Modal.vue';

const props = defineProps<{
  modelValue: boolean;
  car: Car | undefined;
  activeTab: Tab;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
}>();

const router = useRouter();
const showModal = ref(props.modelValue);
watch(
  () => props.modelValue,
  (value) => (showModal.value = value),
);
watch(
  () => showModal.value,
  (value) => emit('update:modelValue', value),
);

const handleOpenWorkshopAppointment = async (appointment: WorkshopAppointment) => {
  showModal.value = false;
  await router.push({ name: 'editWorkshopAppointment', params: { id: appointment.id } });
};
</script>
